module.exports = __webpack_public_path__ + "img/disposable_dishes.5ad96413.svg";